import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import apiService from './services/api'
import { attachUpdateRegistration, notifyChunkError, startAppUpdates } from './services/appUpdateService'
import { watchGameUpdateSafety } from './services/appUpdateSafety'

const stopUpdates = startAppUpdates()
const stopSafety = watchGameUpdateSafety()
if (import.meta.hot) import.meta.hot.dispose(() => { stopUpdates(); stopSafety() })

// Регистрация service worker (везде кроме Telegram Mini App)
const isTelegramMiniApp = apiService.hasTelegramInitData()

if ('serviceWorker' in navigator && !isTelegramMiniApp) {
  navigator.serviceWorker
    .register('/sw.js', { scope: '/', updateViaCache: 'none' })
    .then((registration) => {
      console.log('✅ SW зарегистрирован:', registration.scope)

      // Проверками при возврате во вкладку управляет appUpdateService
      attachUpdateRegistration(registration)
    })
    .catch((error) => {
      console.error('❌ Ошибка регистрации SW:', error)
    })

  // Перезагрузка после активации SW выполняется только из applyAppUpdate по кнопке
}

// Защита от ошибок загрузки чанков после обновления SW
// Если старая страница запросит чанк с устаревшим хешем — предлагаем обновление
window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason
  const message = reason?.message || String(reason)
  if (message.includes('Failed to fetch dynamically imported module') || message.includes('Importing a module script failed')) {
    // Восстановление без принудительной перезагрузки и риска прервать игру
    notifyChunkError()
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
